import { render } from "./MyAccountSecurity.vue?vue&type=template&id=bce4681e"
import script from "./MyAccountSecurity.vue?vue&type=script&lang=js"
export * from "./MyAccountSecurity.vue?vue&type=script&lang=js"

import "./MyAccountSecurity.vue?vue&type=style&index=0&id=bce4681e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__